import { Component, OnInit } from '@angular/core';
import { TemplateService } from '../template-listing/template.service';


@Component({
  selector: 'app-template-mapping-listing',
  templateUrl: './template-mapping-listing.component.html',
  styleUrls: ['./template-mapping-listing.component.css']
})
export class TemplateMappingListingComponent implements OnInit {

  totalCount = 0;
  sentCount = 0;
  progress = 0;
  status = 'Idle';
  isSending = false;
  token:any;
  failedCount:any = 0;
  storedData: any


  progressData:any = [];

  constructor(private templateService:TemplateService) { }

  ngOnInit(): void {
     this.token = localStorage.getItem('token');
      this.storedData = JSON.parse(localStorage.getItem("user") || '{}');
      this.trackProgress();
  }


  startSending() {
    this.isSending = true;
    this.status = 'Sending...';
    this.sentCount = 0;
    this.progress = 0;
   

    // 🔹 Trigger backend API
    // this.emailService.startBulkEmailProcess().subscribe({
    //   next: () => {
    //     // Begin polling for progress
    //     this.trackProgress();
    //   },
    //   error: () => {
    //     this.status = 'Error starting process';
    //     this.isSending = false;
    //   }
    // });
  }

  trackProgress() {
     this.templateService.mailProgress(this.token,{})
        .subscribe((response: any) => {
          if (response.status === 1) {
              this.totalCount = response.data[0].totalFileCount;
              this.progressData = response.data;
              this.progressData.forEach((e:any) => {
                    if(e.status=='SENT'){
                       this.sentCount = this.sentCount + 1;
                    }

                    if(e.status=='FAILED'){
                       this.failedCount = this.failedCount + 1;
                    }

                    console.log(this.sentCount , this.failedCount)

                    
              });
             this.progress = this.sentCount + this.failedCount ;
             if(this.progress==this.totalCount){
                this.progress = 100;
             }
             console.log(this.progress)
          }
        })
    
  }

  cancelSending() {
    // this.emailService.cancelEmailProcess().subscribe(() => {
    //   this.status = 'Cancelled';
    //   this.isSending = false;
    //   this.progressSub?.unsubscribe();
    // });
  }

  ngOnDestroy() {
    // this.progressSub?.unsubscribe();
  }

}
